import React from "react";

function ContactSection() {
  return (
    <section className="section section-muted" id="contact">
      <div className="container contact-layout">
        <div>
          <h2>Ready to talk about your next project?</h2>
          <p>
            Email us at{" "}
            <a href="mailto:vuzeniktech@gmail.com" className="link-accent">
              vuzeniktech@gmail.com
            </a>{" "}
            or call us at{" "}
            <a href="tel:+918008105100" className="link-accent">
              +91 80081 05100
            </a>
            . We’ll get back to you within one business day.
          </p>
        </div>

        <div className="contact-buttons">
          <a href="mailto:vuzeniktech@gmail.com" className="btn-primary">
            Email Us
          </a>

          <a href="tel:+918008105100" className="btn-secondary">
            Call Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
